module.exports = __webpack_public_path__ + "static/media/bg.1abb0fc7.jpg";